import { CalendarOutlined } from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import type { DateRange } from "../../types";
import {
  DatePopupWrap,
  DateRangePill,
  WelcomeBlock,
  WelcomeControls,
  WelcomeRow,
  WelcomeSubtitle,
  WelcomeTitle,
} from "../../style";

dayjs.extend(customParseFormat);

interface WelcomeBarProps {
  name: string;
  dateRange: DateRange;
  onDateRangeChange: (value: DateRange) => void;
}

export default function WelcomeBar({
  name,
  dateRange,
  onDateRangeChange,
}: WelcomeBarProps) {
  return (
    <WelcomeRow align="flex-start" justify="space-between" gap={16} wrap="wrap">
      <WelcomeBlock vertical gap={4}>
        <WelcomeTitle level={2}>Welcome back, {name}!</WelcomeTitle>
        <WelcomeSubtitle>
          Manage relevant user accounts and control who can access patient
          data.
        </WelcomeSubtitle>
      </WelcomeBlock>

      <WelcomeControls align="center" gap={12} wrap="wrap">
        <DateRangePill
          value={dateRange}
          onChange={(values) =>
            onDateRangeChange((values as DateRange) ?? null)
          }
          format="DD/MM/YYYY"
          allowClear
          allowEmpty={[true, true]}
          placeholder={["Start date", "End date"]}
          disabledDate={(current: Dayjs) => current.isAfter(dayjs(), "day")}
          prefix={<CalendarOutlined />}
          panelRender={(panel: React.ReactNode) => (
            <DatePopupWrap>{panel}</DatePopupWrap>
          )}
        />
      </WelcomeControls>
    </WelcomeRow>
  );
}
